import CollapseTitle from "domains/dashboard/components/CollapseTitle/CollapseTitle";

export default CollapseTitle;
